import { render, staticRenderFns } from "./personage.vue?vue&type=template&id=3b2169a8&scoped=true&"
import script from "./personage.vue?vue&type=script&lang=js&"
export * from "./personage.vue?vue&type=script&lang=js&"
import style0 from "./personage.vue?vue&type=style&index=0&id=3b2169a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2169a8",
  null
  
)

export default component.exports